import { Sort, SortDirection } from '@angular/material/sort';
import { sortDirection } from '@sharedModule/constants/data-grid.constants';
const { asc } = sortDirection;

/**
 * Use this function when trying to sort on a fallback/default sort.
 * Since, fallback can only have ascending/descending sort direction.
 * We want to switch between asc & desc only instead of asc->desc->"".
 * So, for the fallback sort, sorting flow will be asc->desc->asc->desc...(cyclic)
 * @param direction Represent direction of the sort
 * @returns return sort direction which can only be asc/desc
 */
export const getFallbackSortDirection = (
  direction: SortDirection
): SortDirection => (direction === '' ? asc : direction);

export const isFallBackSort = (activeSort: Sort, fallBackSort: Sort): boolean =>
  activeSort.active === fallBackSort.active;

export const getActiveSort = (activeSort: Sort, fallBackSort: Sort): Sort => {
  if (!isFallBackSort(activeSort, fallBackSort)) {
    return activeSort.direction !== '' ? activeSort : fallBackSort;
  }
  return {
    ...activeSort,
    direction: getFallbackSortDirection(activeSort.direction),
  };
};
